// extracted by mini-css-extract-plugin
module.exports =  {"attributes-tooltip-wrapper":"B0onAFX","attributesTooltipWrapper":"B0onAFX","attribute-item":"m89aPir","attributeItem":"m89aPir"};